import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-help-feedback',
  templateUrl: './help-feedback.component.html'
})
export class HelpFeedbackComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private router: Router, private sanitizer: DomSanitizer) { }
  fb_header;
  fb_desc;
  fb_para1header;
  fb_para1body;
  fb_para2header;
  fb_para2body;
  ngOnInit(): void {
   
    this.commonDataService.showLoader.next(true);
    this.gethelpfeedbacklabels();
  }
  gethelpfeedbacklabels() {
    this.graphQlService.gethelpfeedbackLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.fb_header = labels.filter(x => x.key == "fb_header").map(y => y.value);
        this.fb_desc = labels.filter(x => x.key == "fb_desc").map(y => y.value);
        this.fb_para1header = labels.filter(x => x.key == "fb_para1header").map(y => y.value);
        this.fb_para2header =  labels.filter(x => x.key == "fb_para2header").map(y => y.value);
        this.fb_para1body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "fb_para1body").map(y => y.value));
        this.fb_para2body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "fb_para2body").map(y => y.value));
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
  openlinkById(event) {
    let id = event.target.id;
    if (id != "") {
      this.router.navigate([id]);
    }
  }
  openFeedback(event) {
    let id = event.target.id;
    if (id != "") {
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.rightOverlayOption.next("General Feedback");
    }
  }
}
